import styled from 'styled-components';

const PageHeading = ({ children }) => <S.Heading>{children}</S.Heading>;

const S = {
  Heading: styled.h1`
    margin: 0;
    font-size: 2rem;
    font-weight: 500;
    letter-spacing: -0.1px;
    line-height: 1.35;
    color: ${({ theme }) => theme.colors.bodyText};
  `,
};

export default PageHeading;
